import { getToken } from './../../../../services/services-jwt'

export default {
    userToken : getToken() || null
}
